import { render, staticRenderFns } from "./Marketing.vue?vue&type=template&id=0879d4b4&scoped=true&"
import script from "./Marketing.vue?vue&type=script&lang=js&"
export * from "./Marketing.vue?vue&type=script&lang=js&"
import style0 from "./Marketing.vue?vue&type=style&index=0&id=0879d4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0879d4b4",
  null
  
)

export default component.exports